import { render, staticRenderFns } from "./accountStatement.vue?vue&type=template&id=0fcaa49a&scoped=true&"
import script from "./accountStatement.vue?vue&type=script&lang=js&"
export * from "./accountStatement.vue?vue&type=script&lang=js&"
import style0 from "./accountStatement.vue?vue&type=style&index=0&id=0fcaa49a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcaa49a",
  null
  
)

export default component.exports